/** Shared premium eligibility — Stripe active sub OR valid manual admin grant. */

export function isManualPremiumValid(user, nowMs = Date.now()) {
  if (!user) return false;
  const source = user.subscriptionSource ?? user.subscription_source;
  if (source !== "manual") return false;
  if (user.subscriptionActive !== true && user.subscription_active !== true) return false;

  const until = user.premiumUntil ?? user.premium_until;
  if (until == null || until === "") return true;

  const t = new Date(until).getTime();
  return Number.isFinite(t) && t > nowMs;
}

export function isStripePremiumActive(user) {
  if (!user) return false;
  const source = user.subscriptionSource ?? user.subscription_source ?? "stripe";
  if (source === "manual") return false;
  const active = user.subscriptionActive ?? user.subscription_active;
  return active === true || active === "true" || active === 1;
}

/** True when the user should receive premium features right now. */
export function isUserPremium(user, nowMs = Date.now()) {
  if (!user) return false;
  if (isManualPremiumValid(user, nowMs)) return true;
  if (isStripePremiumActive(user)) return true;
  return false;
}

export function premiumUntilLabel(user) {
  const until = user?.premiumUntil ?? user?.premium_until;
  if (!until) return null;
  try {
    return new Date(until).toLocaleDateString(undefined, {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  } catch {
    return until;
  }
}

/** Add months to now for admin grant durations. */
export function addMonthsFromNow(months) {
  const d = new Date();
  d.setMonth(d.getMonth() + months);
  return d.toISOString();
}
